module.exports = __webpack_public_path__ + "img/mobexHealthHome.562de21d.png";